import React, { useEffect, useState } from 'react'
import * as AnalyticsService from '../../services/analytics'
import { useAnalyticsFilters } from '../../contexts/AnalyticsFilterContext'
import AnalyticsPageShell from './components/AnalyticsPageShell'
import MetricsSection from './components/MetricsSection'
import InsightsPanel from './components/InsightsPanel'
import { SingleSeriesChart } from './components/SeriesChart'
import { getAnalyticsErrorMessage } from './utils'

const Reminders = () => {
    const { rangeFilters } = useAnalyticsFilters()
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState(null)
    const [data, setData] = useState(null)

    useEffect(() => {
        let cancelled = false

        async function load() {
            setLoading(true)
            setError(null)
            try {
                const response = await AnalyticsService.getReminders(rangeFilters)
                if (!cancelled) setData(response)
            } catch (err) {
                if (!cancelled) setError(getAnalyticsErrorMessage(err))
            } finally {
                if (!cancelled) setLoading(false)
            }
        }

        load()
        return () => {
            cancelled = true
        }
    }, [rangeFilters])

    return (
        <AnalyticsPageShell title='Análises de negócio — Lembretes' loading={loading} error={error} showWorkshopId>
            <MetricsSection title='Inventário (estado atual)' metrics={data?.inventory} />
            <MetricsSection title='Atividade no período (eventos)' metrics={data?.activity} />
            <SingleSeriesChart
                title='Conclusões ao longo do tempo (eventos)'
                points={data?.completionsOverTime}
                dataKey='conclusões'
            />
            <InsightsPanel insights={data?.insights} />
        </AnalyticsPageShell>
    )
}

export default Reminders
